//对资源后缀进行分类
const type={
    video:["flv","swf","asf","avi","mpg","3gp","mp3","mp4","wav","rm","rmvb","wmv","flv","MTS"],
    document:["ppt","pptx","doc","docx","xls","xlsx","pdf"],
    picture:["jpg","jpeg","png","tif","tiff","bmp","gif"]
};
module.exports = function(suffix){
    for(let i in type){
        if(type[i].indexOf(suffix)>-1){
            return i;
        }
    }
};
